export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const fmtK = (v) => {
  if (v == null || isNaN(v)) return "–";
  const abs = Math.abs(v);
  if (abs >= 1_000_000_000) {
    return `$${(v / 1_000_000_000).toFixed(2)}B`;
  }
  if (abs >= 10_000_000) {
    return `$${(v / 1_000_000).toFixed(2)}M`;
  }
  const k = Math.round(v / 1000);
  return `$${k.toLocaleString()}K`;
};

export const fmtPct = (v) => {
  if (v == null || isNaN(v)) return null;
  const sign = v >= 0 ? "+" : "";
  return `${sign}${v.toFixed(1)}%`;
};

export const fmtDelta = (v) => {
  if (v == null || isNaN(v)) return null;
  const sign = v >= 0 ? "+" : "";
  const abs = Math.abs(v);
  if (abs >= 1_000_000_000) {
    return `${sign}${(v / 1_000_000_000).toFixed(2)}B`;
  }
  if (abs >= 10_000_000) {
    return `${sign}${(v / 1_000_000).toFixed(2)}M`;
  }
  const k = Math.round(v / 1000);
  return `${sign}${k.toLocaleString()}K`;
};

export const paceColor = (status) => {
  if (status === "AHEAD") return "#2e7d32";
  if (status === "ON TRACK") return "#1565c0";
  if (status === "BEHIND") return "#c62828";
  return "#555";
};

export const paceBg = (status) => {
  if (status === "AHEAD") return "#e8f5e9";
  if (status === "ON TRACK") return "#e3f2fd";
  if (status === "BEHIND") return "#ffebee";
  return "#f5f5f5";
};
